import { useEffect } from 'react';

import { getMod, useReduxSelector } from 'services/hooks';

export interface IUseSelectEducationProps {
  clearEducationState: () => void;
}

export const useSelectEducation = (props: IUseSelectEducationProps) => {
  const { clearEducationState } = props;

  const educationLevels = useReduxSelector(
    (redux) => redux.app.educationLevels
  );

  const isGamifiedEducation = useReduxSelector((redux) =>
    Boolean(redux.app.gameMods?.gamifiedEducation)
  );

  const isEducationRestricted =
    getMod('gamifiedEducation')?.hooks.useEducationRestricted() ?? false;

  useEffect(() => {
    clearEducationState();
  }, [clearEducationState]);

  return {
    educationLevels,
    isGamifiedEducation,
    isEducationRestricted,
  };
};
